<div class="sidebar-outer">
    <a class="logo d-flex align-items-center"  (click)="closeSubMenus()" *ngIf="settings.theme.sidebarIsFixed">
        <span class="start"></span><span class="ng"><img src="./../../../../assets/icon.jpeg" style="height: 40px; width: 70px; margin-left: -10px"></span>
    </a>
    <app-vertical-menu [menuItems]="menuItems"></app-vertical-menu>    
</div>